export enum Endpoints {
  AuthSignIn = '/v1/gigsafe/client/auth/sign-in',
  AuthSignUp = '/v1/gigsafe/client/auth/sign-up',
  AuthValidateOtc = '/v1/gigsafe/client/auth/validate-otc',

  FetchDriver = '/v1/gigsafe/client',
  FetchPartner = '/v1/gigsafe/client/partner',

  RequestUploadUrl = '/v1/gigsafe/client/steps/request-upload-url',

  UploadForm = '/v1/gigsafe/client/steps/form',
  SkipStep = '/v1/gigsafe/client/steps/skip-step',

  UploadVehicleInsurance = '/v1/gigsafe/client/steps/upload-insurance',
  UploadInsuranceDeclaration = '/v1/gigsafe/client/steps/upload-insurance-declaration',
  UploadInsuranceCoverage = '/v1/gigsafe/client/steps/insurance-policy',
  UploadInsuranceBeneficiary = '/v1/gigsafe/client/steps/insurance-beneficiary',
  UploadVaccination = '/v1/gigsafe/client/steps/vaccination-information',
  UploadVehicleRegistration = '/v1/gigsafe/client/steps/upload-vehicle-registration',
  UploadEIN = '/v1/gigsafe/client/steps/handle-business-entity',
  UploadBGC = '/v1/gigsafe/client/steps/upload-background-check',
  UploadMVR = '/v1/gigsafe/client/steps/upload-mvr',
  FetchPaymentMethod = '/v1/gigsafe/payments/driver/payment-method',
  UploadPaymentMethod = '/v1/gigsafe/client/steps/payment-method',
  ValidateMCNumber = '/v1/gigsafe/client/steps/mc-number/validate',
  UploadMCNumber = '/v1/gigsafe/client/steps/mc-number',
  ValidateUSDOTNumber = '/v1/gigsafe/client/steps/dot-number/validate',
  UploadDOTNumber = '/v1/gigsafe/client/steps/dot-number',
  UploadSSN = '/v1/gigsafe/client/steps/ssn',
  SubmitTemporaryDriverLicense = '/v1/gigsafe/client/steps/temporary-driver-license',
  FetchOptOutProducts = '/v1/gigsafe/client/steps/:collectDataStepId/insurance-policy-product/:insurancePolicyProductId',
  SetPersonaStarted = '/v1/gigsafe/client/steps/persona-started',

  FetchPersonaInquiry = '/v1/gigsafe/integrations/persona/inquiry',
  SetPersonaSessionToken = '/v1/gigsafe/integrations/persona/inquiry/sessionToken',
  SetPersonaClientCompletedInquiry = '/v1/gigsafe/integrations/persona/inquiry/client-completed',

  FetchYardstikReport = '/v1/gigsafe/integrations/background-check/report',

  DocusignStartSigning = '/v1/gigsafe/integrations/docusign/start-signing',
  DocusignCompleteSigning = '/v1/gigsafe/integrations/docusign/complete-signing',
  DocusignDeclineSigning = '/v1/gigsafe/integrations/docusign/decline-signing',
  FetchDocusignSigningEnvelopeOptions = '/v1/gigsafe/integrations/docusign/signing-envelope-options',

  FetchNhtsaDecodedVin = '/v1/gigsafe/integrations/nhtsa/decoded-vin',

  FetchLMSTrainingState = '/v1/gigsafe/integrations/lms/state',
  CompleteLMSTrainingStep = '/v1/gigsafe/integrations/lms/complete',
  UploadLMSCertificate = '/v1/gigsafe/integrations/lms/upload-certificate',

  FetchPartnerPublicInfo = '/v1/partners/public/:partnerName',

  FetchPublicOpportunity = '/v1/opportunities/public/:publicToken',
  SubmitOpportunityApplication = '/v1/opportunities/public/:publicToken/applications',

  ContractorPortalSignInPhone = '/v1/gigsafe/client/auth/sign-in',
  ContractorPortalFetchPartners = '/v1/gigsafe/client/portal/partners',
  ContractorPortalSignInEnterCode = '/v1/gigsafe/client/auth/validate-otc',

  ContractorPortalSendCode = '/v1/gigsafe/client/portal/verify/send',
  ContractorPortalVerifyCode = '/v1/gigsafe/client/portal/verify',

  ContractorPortalFetchPartner = '/v1/gigsafe/client/partner',
  ContractorPortalFetchDriver = '/v1/gigsafe/client',
  ContractorPortalFetchInvoices = '/v1/gigsafe/client/portal/partners/invoices',
  ContractorPortalFetchInvoice = '/v1/gigsafe/client/portal/partners/invoices/:invoiceId',
  ContractorPortalFetchDocuments = '/v1/gigsafe/client/portal/reports',
  ContractorPortalFetchCertificates = '/v1/gigsafe/client/portal/certificates',
  ContractorPortalDownloadCertificate = '/v1/gigsafe/client/portal/certificates/:certificateId/download',
  ContractorPortalUpdatePhoneSendCode = '/v1/gigsafe/client/portal/phone/verification-code',
  ContractorPortalUpdatePhone = '/v1/gigsafe/client/portal/phone',
  ContractorPortalUpdateEmailSendCode = '/v1/gigsafe/client/portal/email/verification-code',
  ContractorPortalUpdateEmail = '/v1/gigsafe/client/portal/email',

  ContractorPortalSwitchPartner = '/v1/gigsafe/client/portal/partners/switch',
  RemoteConfig = '/v1/gigsafe/remote-config/client',
}
